import { configureStore, combineReducers } from '@reduxjs/toolkit';
import genbiReducer from './genbiSlice';
import textractorReducer from './textractorSlice';
import genbookReducer from './genbookSlice';
import copilotReducer from './copilotSlice';
import airspaceReducer from './airspaceSlice';
import literatureDiscoveryReducer from './literatureDiscoverySlice';
import screeningSpaceReducer from './screeningSpaceSlice';
import teamReducer from './teamSlice';
import unstructuredThreadReducer from './unstructuredThreadSlice';
import dataFabricReducer from './dataFabricSlice';
import askSaraReducer from './askSaraSlice';
import genaiRightsReducer from './genaiRightsSlice';

const appReducer = combineReducers({
  genbi: genbiReducer,
  textractor: textractorReducer,
  genbook: genbookReducer,
  copilot: copilotReducer,
  airspace: airspaceReducer,
  literatureDiscovery: literatureDiscoveryReducer,
  screeningSpace: screeningSpaceReducer,
  team: teamReducer,
  unstructuredThread: unstructuredThreadReducer,
  dataFabric: dataFabricReducer,
  askSara: askSaraReducer,
  genaiRights: genaiRightsReducer,
});

// ── Root reducer: resets entire store on logout ─────────────
// forces every slice reducer to return its own initialState.
const rootReducer = (state, action) => {
  if (action.type === 'RESET_ALL_STATE') {
    return appReducer(undefined, action);
  }
  return appReducer(state, action);
};

const store = configureStore({
  reducer: rootReducer,
});

export default store;